<template>
    <ModalDrawer></ModalDrawer>
</template>
<script>
import ModalDrawer from './ModalDrawer.vue'

export default {
    components: { ModalDrawer }
}
</script>
<style scoped lang="scss">

</style>
